import apiClient from './apiClient';

// Acta de nacimiento por hijo, compartida entre Jubilación y Plan de Pago (y cualquier
// trámite futuro con hijos del Cliente). El endpoint vive en la base /api/tramites/{idTramite}
// (no bajo /tramites/jubilacion o /tramites/plan-pago), por eso es un servicio aparte.
export const actualizarActaHijo = async (idTramite, idHijo, { presentado, idArchivo }) => {
    const response = await apiClient.patch(`/tramites/${idTramite}/actas/${idHijo}`, { presentado, idArchivo });
    return response.data;
};

const actaHijoService = { actualizarActaHijo };

export default actaHijoService;
